import React, { useEffect, useState } from "react";

const SuggestionTaxSavingModal = ({
  isOpen,
  onClose,
  onStart,
  onSkip,
  isLoading = false,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const [showButtons, setShowButtons] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      setShowButtons(true);
      setTimeout(() => setIsAnimating(true), 10);
    } else {
      setIsAnimating(false);
      setShowButtons(false);
      setTimeout(() => setIsVisible(false), 300);
    }
  }, [isOpen]);

  if (!isOpen && !isVisible) return null;

  const handleStart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const button = e.currentTarget;
    const ripple = document.createElement("span");
    const rect = button.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const x = e.clientX - rect.left - size / 2;
    const y = e.clientY - rect.top - size / 2;
    ripple.style.width = ripple.style.height = `${size}px`;
    ripple.style.left = `${x}px`;
    ripple.style.top = `${y}px`;
    ripple.classList.add("ripple");
    button.appendChild(ripple);
    setTimeout(() => ripple.remove(), 600);
    onStart?.();
  };

  const handleSkip = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const button = e.currentTarget;
    const ripple = document.createElement("span");
    const rect = button.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const x = e.clientX - rect.left - size / 2;
    const y = e.clientY - rect.top - size / 2;
    ripple.style.width = ripple.style.height = `${size}px`;
    ripple.style.left = `${x}px`;
    ripple.style.top = `${y}px`;
    ripple.classList.add("ripple");
    button.appendChild(ripple);
    setTimeout(() => ripple.remove(), 600);
    onSkip?.();
  };

  return (
    <>
      <div
        className={`fixed inset-0 z-50 flex items-center justify-center bg-black transition-all duration-500 ease-out ${
          isVisible ? "opacity-100" : "opacity-0"
        } ${isOpen ? "bg-opacity-30" : "bg-opacity-0"}`}
        onClick={(e) => e.target === e.currentTarget && onClose?.()}
      >
        <div
          className={`bg-white rounded-3xl max-w-md w-full mx-4 px-6 sm:px-8 py-5 sm:py-6 text-center shadow-2xl relative transform transition-all duration-500 ease-out ${
            isAnimating && isOpen
              ? "scale-100 opacity-100 translate-y-0"
              : "scale-90 opacity-0 translate-y-8"
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="absolute inset-0 rounded-3xl overflow-hidden pointer-events-none">
            <div className="absolute -top-20 -right-20 w-64 h-64 bg-gradient-to-br from-[#8AB9F1] via-[#B57EDC] to-[#F08080] rounded-full opacity-10 blur-3xl animate-pulse" />
            <div
              className="absolute -bottom-20 -left-20 w-64 h-64 bg-gradient-to-tr from-[#F08080] via-[#B57EDC] to-[#8AB9F1] rounded-full opacity-10 blur-3xl animate-pulse"
              style={{ animationDelay: "1s" }}
            />
          </div>

          <h2
            className={`text-xl sm:text-2xl font-bold text-[#141A33] mb-4 transition-all duration-700 delay-100 ease-out relative z-10 text-left ${
              isAnimating ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
            }`}
          >
            Did you know you can also save tax this year?
          </h2>

          <div
            className={`space-y-5 text-left transition-all duration-700 delay-200 ease-out relative z-10 ${
              isAnimating ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
            }`}
          >
            <p className="text-base text-[#141A33] font-semibold leading-relaxed">
              Yes, as well as getting a refund for past tax years, you can also pay less tax{" "}
              <span className="text-[#F28789] font-bold">right now!</span>
            </p>
            <p className="text-base text-[#141A33] font-semibold leading-relaxed">
              Find out how much you can save in just{" "}
              <span className="text-[#F28789] font-bold">1m</span>
            </p>
          </div>

          {/* Reserve space for buttons so content doesn't jump when they appear */}
          <div className="mt-6 min-h-[100px] flex flex-col justify-end relative z-10">
            {showButtons && (
              <div
                className={`space-y-4 transition-all duration-700 ease-out ${
                  isAnimating ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
                }`}
              >
                <button
                  onClick={handleStart}
                  disabled={isLoading}
                  className="w-full bg-[#002147] text-white py-3.5 rounded-xl font-semibold hover:bg-[#001730] transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-[1.02] active:scale-[0.98] relative overflow-hidden disabled:opacity-70 disabled:cursor-not-allowed"
                >
                  <span className="relative z-10">
                    {isLoading ? "Starting…" : "Continue"}
                  </span>
                </button>
                <button
                  onClick={handleSkip}
                  disabled={isLoading}
                  className="w-full py-3 text-[#8A8D99] font-semibold hover:text-[#6B6E78] transition-colors disabled:opacity-70"
                >
                  Skip
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes ripple {
          to {
            transform: scale(4);
            opacity: 0;
          }
        }
        .ripple {
          position: absolute;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.6);
          transform: scale(0);
          animation: ripple 600ms ease-out;
          pointer-events: none;
          z-index: 1;
        }
      `}</style>
    </>
  );
};

export default SuggestionTaxSavingModal;
